// import React from 'react';
// import { ReactComponent as Download } from '../images/download-solid.svg';
// import CV from '../images/SODIQ-AZEEZ-CV.pdf';
// import introBg from '../images/introBg.png';
// import { ReactComponent as ReactIcon } from '../images/react-brands.svg';
// import { ReactComponent as VueIcon } from '../images/vue-svg.svg';
// import { ReactComponent as AngularIcon } from '../images/angular-icon.svg';
// import { ReactComponent as NodeIcon } from '../images/nodejs-logo-svg.svg';





// const Intro = () => {

//     return (
//         <section className="Intro" id='intro'>
//             <div className="container introContainer">
//                 <div className="row">
//                     <div className="col-md-6 introContent">
//                         <div className="content">
//                             <h2 >👋🏽 Hi, I'm Sodiq Azeez</h2>
//                             <h4>Full-Stack Developer</h4>
//                             <p>
//                                 A Web developer, with extensive knowledge of working with web technologies and delivering quality work.
//                             </p>
//                             <a href={CV} download className="resumeBtn">
//                                 Get Resume
//                                 <Download />
//                             </a>
//                         </div>
//                     </div>
//                     <div className="col-md-6 introImg">
//                         <div className="outerCircle">
//                             <ReactIcon />
//                             <AngularIcon />
//                             <VueIcon />
//                             <NodeIcon />


//                         </div>
//                         <div className="innerCircle">
//                             <img src={introBg} alt="Intro background" className="innerImage img-fluid" />
//                         </div>
//                     </div>
//                 </div>
//             </div>

//         </section>
//     )
// }

// export default Intro

import React from 'react';
import { ReactComponent as Download } from '../images/download-solid.svg';
import CV from '../images/SODIQ-AZEEZ-CV.pdf';
import introBg from '../images/introBg.png';
import { ReactComponent as ReactIcon } from '../images/react-brands.svg';
import { ReactComponent as VueIcon } from '../images/vue-svg.svg';
import { ReactComponent as AngularIcon } from '../images/angular-icon.svg';
import { ReactComponent as NodeIcon } from '../images/nodejs-logo-svg.svg';

const Intro = () => {

    return (
        <section className="Intro" id='intro'>
            <div className="container introContainer">
                <div className="row">
                    <div className="col-md-6 introContent">
                        <div className="content">
                            <h2>👋🏽 Hi, I'm Sodiq Azeez</h2>
                            <h4>Software Engineer | Full-Stack Developer</h4>
                            <p>
                                I transform complex challenges into elegant solutions. Specializing in AI Integration, Full-Stack Development, and Enterprise Architecture. I build scalable applications that drive real impact and business growth.
                            </p>
                            <a href={CV} download className="resumeBtn">
                                Get Resume
                                <Download />
                            </a>
                        </div>
                    </div>
                    <div className="col-md-6 introImg">
                        <div className="outerCircle">
                            <ReactIcon />
                            <AngularIcon />
                            <VueIcon />
                            <NodeIcon />
                        </div>
                        <div className="innerCircle">
                            <img src={introBg} alt="Intro background" className="innerImage img-fluid" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Intro